import React, { useState, useEffect } from "react";
import { Link, useParams, useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Spinner,
  Button,
} from "reactstrap";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// availity-reactstrap-validation
import { AvForm, AvField } from "availity-reactstrap-validation";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

//i18n
import { withTranslation } from "react-i18next";

import { useDispatch, useSelector } from "react-redux";

// actions
import {
  getSystemUser,
  createSystemUser,
  editSystemUser,
  resetSystemUser,
  resetSystemUsers,
  resetError,
} from "../../store/actions";

const NewSystemUser = ({ t }) => {
  let { idSystemUser } = useParams();
  const dispatch = useDispatch();
  const history = useHistory();

  const {
    dataSystemUserGetSet,
    dataSystemUserEditCreate,
    loadingSystemUser,
    loadingSystemUserEditCreate,
    successSystemUser,
    errorSystemUser,
  } = useSelector((state) => state.SystemUser);

  const [userValues, setSystemUserValues] = useState({
    name: "",
    email: "",
    nickname: "",
    profiles: [],
    profilesBk: [],
  });

  const [newFields, setNewFields] = useState({});
  const [enableSubmit, setEnableSubmit] = useState(false);

  const handleCreateEditSystemUser = () => {
    if (idSystemUser) {
      dispatch(editSystemUser(idSystemUser, newFields));
    } else {
      dispatch(createSystemUser(newFields));
    }
  };

  const showToast = (type, message) => {
    toastr[type](message);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "2000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
    onHidden: () =>
      successSystemUser &&
      dispatch(resetSystemUser()) &&
      dispatch(resetSystemUsers()) &&
      history.push("/systemusers"),
  };

  const checkSubmit = () => {
    if (Object.keys(newFields).length !== 0) setEnableSubmit(true);
    else setEnableSubmit(false);
  };

  useEffect(() => {
    checkSubmit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [newFields]);

  useEffect(() => {
    dispatch(resetSystemUser());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (idSystemUser) {
      dispatch(getSystemUser(idSystemUser, true));
    } else {
      dispatch(getSystemUser(null, true));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idSystemUser]);

  useEffect(() => {
    if (
      idSystemUser &&
      dataSystemUserGetSet &&
      dataSystemUserGetSet.data &&
      dataSystemUserGetSet.data.systemUser
    ) {
      let profilesToPrint = [];
      if (dataSystemUserGetSet.data.systemUser.profiles) {
        profilesToPrint = dataSystemUserGetSet.data.systemUser.profiles.map(
          (profile, key) => ({
            key: key,
            value: profile.id,
            label: profile.name,
          })
        );
      }
      setSystemUserValues((previous) => ({
        ...previous,
        name: dataSystemUserGetSet.data.systemUser.name,
        email: dataSystemUserGetSet.data.systemUser.email,
        nickname: dataSystemUserGetSet.data.systemUser.nickname,
        profiles: dataSystemUserGetSet.data.systemUser.profiles[0].id,
        profilesBk: profilesToPrint.map((item) => item.value),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataSystemUserGetSet]);

  useEffect(() => {
    if (dataSystemUserEditCreate && dataSystemUserEditCreate.message) {
      showToast("success", t(dataSystemUserEditCreate.message));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [successSystemUser]);

  useEffect(() => {
    if (errorSystemUser && typeof errorSystemUser === "object") {
      errorSystemUser.map((error) => showToast("error", t(error.value)));
      dispatch(resetError());
    } else {
      if (errorSystemUser) {
        showToast("error", t(errorSystemUser));
        dispatch(resetError());
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [errorSystemUser]);

  const optionsProfile = () => {
    let options = [];

    if (loadingSystemUser) {
      options.push({
        value: "empty",
        label: `${t("Loading")} ...`,
        isDisabled: true,
      });
    } else {
      if (
        dataSystemUserGetSet &&
        dataSystemUserGetSet.data &&
        dataSystemUserGetSet.data.form &&
        dataSystemUserGetSet.data.form.profiles &&
        dataSystemUserGetSet.data.form.profiles.length > 0
      ) {
        options.push({
          value: "",
          label: t("Select"),
          isDisabled: true,
        });
        dataSystemUserGetSet.data.form.profiles.map((profile, key) =>
          options.push({
            key: key,
            value: profile.id,
            label: profile.name,
          })
        );
      } else {
        options.push({
          value: "empty",
          label: t("No matching records found"),
          isDisabled: true,
        });
      }
    }

    return options;
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            mainPath="/systemusers"
            path={idSystemUser ? "/systemuser/" + idSystemUser : "/systemuser"}
            title={t("System users")}
            breadcrumbItem={!idSystemUser ? t("Create system user") : t("Edit System User")}
          />
          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm onValidSubmit={handleCreateEditSystemUser}>
                    <Row>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            label={t("Name") + " *"}
                            id="name"
                            name="name"
                            type="text"
                            className="form-control"
                            placeholder={t("System user name")}
                            onChange={(e) => {
                              if (e.target.value === userValues.name) {
                                delete newFields.name;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  name: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.name}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              maxLength: {
                                value: 50,
                                errorMessage: t("Invalid field"),
                              },
                              pattern: {
                                value: "/^[A-Za-z áàâãéèêíïóôõöúç]*$/i", // only letters and space
                                errorMessage: t(
                                  "Your name must be composed only with letter and space"
                                ),
                              },
                            }}
                          />
                        </FormGroup>
                        <FormGroup>
                          <AvField
                            label={t("Email") + " *"}
                            id="registration-email"
                            name="registrationemail"
                            type="email"
                            className="form-control"
                            placeholder={t("example@example.com")}
                            onChange={(e) => {
                              if (e.target.value === userValues.email) {
                                delete newFields.email;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  email: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.email}
                            validate={{
                              email: {
                                value: true,
                                errorMessage: t("Incorrect email"),
                              },
                              maxLength: {
                                value: 100,
                                errorMessage: t("Invalid field"),
                              },
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="6">
                        <FormGroup>
                          <AvField
                            label={t("Nickname") + " *"}
                            id="nickname"
                            name="nickname"
                            type="text"
                            className="form-control"
                            placeholder={t("System user nickname")}
                            onChange={(e) => {
                              if (e.target.value === userValues.nickname) {
                                delete newFields.nickname;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  nickname: e.target.value,
                                }));
                              }
                            }}
                            value={userValues.nickname}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                              pattern: {
                                value:
                                  "/^[A-Za-z0-9àèìòùÀÈÌÒÙáéíóúýÁÉÍÓÚÝâêîôûÂÊÎÔÛãñõÃÑÕäëïöüÿÄËÏÖÜŸçÇßØøÅåÆæœ]*$/i",
                                errorMessage: t(
                                  "Nickname must be composed only with letters and numbers"
                                ),
                              },
                              minLength: {
                                value: 3,
                                errorMessage: t("Invalid field"),
                              },
                              maxLength: {
                                value: 54,
                                errorMessage: t("Invalid field"),
                              },
                            }}
                          />
                        </FormGroup>

                        <FormGroup className="select2-container">
                          <AvField
                            name="profile"
                            className="form-control"
                            type="select"
                            label={t("Profile") + " *"}
                            onChange={(e) => {
                              let profileId = e.target.value;
                              if (profileId === userValues.profilesBk[0]) {
                                delete newFields.profile_id;
                                checkSubmit();
                              } else {
                                setNewFields((previous) => ({
                                  ...previous,
                                  profile_id: profileId,
                                }));
                              }
                            }}
                            value={userValues.profiles}
                            validate={{
                              required: {
                                value: true,
                                errorMessage: t("Required Field"),
                              },
                            }}
                          >
                            {optionsProfile().map((profile, key) => (
                              <option
                                key={key}
                                value={profile.value}
                                disabled={profile.isDisabled}
                              >
                                {profile.label}
                              </option>
                            ))}
                          </AvField>
                        </FormGroup>
                      </Col>
                    </Row>
                    <Button
                      type="submit"
                      color="primary"
                      className="mr-1 waves-effect waves-light"
                      style={{
                        minWidth: "100px",
                        cursor: enableSubmit ? "pointer" : "no-drop",
                      }}
                      disabled={!enableSubmit}
                    >
                      {loadingSystemUserEditCreate ? (
                        <Spinner
                          size="sm"
                          animation="border"
                          style={{
                            height: "19px",
                            width: "19px",
                          }}
                        />
                      ) : (
                        t("Confirm")
                      )}
                    </Button>
                    <Link to="/systemusers">
                      {" "}
                      <Button
                        type="button"
                        color="secondary"
                        className="waves-effect"
                        onClick={() => dispatch(resetSystemUser())}
                      >
                        {t("Cancel")}
                      </Button>
                    </Link>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(NewSystemUser);
